import { Injectable, signal } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  public isOpen = signal(false)

  public show(): void {
    this.isOpen.set(true)
  }

  public hide(): void {
      this.isOpen.set(false)
  }
}
